import { Button } from '../ui/button';
import { Checkbox } from '../ui/checkbox';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';
import NodeFilterField from './NodeFilterField';

/**
 * Фильтр с несколькими значениями: флаги triage, категории жалоб, мульти-лейблы.
 * Записи фильтра склеиваются на бэкенде через AND, поэтому выбор двух значений означает
 * «отмечены оба признака», а не «любой из них» — об этом написано в подсказке.
 */
const NodeFilterMultiSelect = ({ filter, value, onChange }) => {
  const options = filter.options ?? [];
  const known = new Set(options.map((option) => option.code));
  // Пакет могли перезалить — коды, которых больше нет в каталоге, молча выбрасываем.
  const selected = (Array.isArray(value) ? value : []).filter((code) => known.has(code));

  const toggle = (code) => {
    onChange(selected.includes(code) ? selected.filter((item) => item !== code) : [...selected, code]);
  };

  const summary =
    selected.length === 0
      ? 'Все'
      : selected.length === 1
        ? options.find((option) => option.code === selected[0])?.label ?? selected[0]
        : `Выбрано: ${selected.length}`;

  return (
    <NodeFilterField label={filter.label}>
      <Popover>
        <PopoverTrigger asChild>
          <Button
            variant="outline"
            size="sm"
            data-ev="nodes.filters.multi_open"
            className="h-8 w-full justify-start truncate text-xs font-normal"
          >
            {summary}
          </Button>
        </PopoverTrigger>
        <PopoverContent align="start" className="w-72 p-2">
          <div className="max-h-72 space-y-1 overflow-y-auto">
            {options.map((option) => (
              <label
                key={option.code}
                className="flex cursor-pointer items-center gap-2 rounded px-2 py-1.5 text-sm hover:bg-muted"
              >
                <Checkbox
                  data-ev="nodes.filters.multi_toggle"
                  checked={selected.includes(option.code)}
                  onCheckedChange={() => toggle(option.code)}
                />
                <span className="text-foreground">{option.label}</span>
              </label>
            ))}
          </div>

          {selected.length > 1 && (
            <p className="mt-2 border-t px-2 pt-2 text-xs text-muted-foreground">
              Звонок попадает в выборку, только если отмечены все выбранные значения.
            </p>
          )}

          {selected.length > 0 && (
            <Button variant="ghost" size="sm" data-ev="nodes.filters.multi_reset" className="mt-1 w-full" onClick={() => onChange([])}>
              Сбросить
            </Button>
          )}
        </PopoverContent>
      </Popover>
    </NodeFilterField>
  );
};

export default NodeFilterMultiSelect;
